//请自行添加语言资源
const allocation = {
  creatorUserName: '订单创建人',
  orderDate: '订单日期',
  customerCode: '租赁方',
  consigneeCode: '收货方',
  consigneeAddrCode: '收货地址',
  customerTel: '联系方式',
  customerContact: '联系人',
  expectedDeliveryDate: '预约提货日期',
  orderTypeCode: '订单类型',
  schOrderSkuId: '订单ID',
  remark: '备注',
  skuType: '箱型',
  grossWeight: '重量',
  length:'长',
  width: '宽',
  height:'高(折叠后)',
  skuSaleMinQty: '最小起订量',
  skuQty: '需求数量',
  productName: '产品名称',
  msg:{
    customerCode: '请选择租赁方',
    consigneeCode: '请选择收货方',
    consigneeAddrCode: '请选择收货地址',
    customerContact: '请填写联系人',
    customerTel: '请选择联系方式',
    orderTypeCode: '请选择订单类型',
  }
};
export default allocation



// WEBPACK FOOTER //
// ./src/page/recovery/allocation/lang/allocation.zh.js